import styled from 'styled-components';
import { BackgroundColor, Spacer } from '@lux/tokens';
import { Title } from '@lux/title';
import { mediaMaxWidth } from '@lux/templates';
import { ChevronLeftXS } from '@lux/zds-icons';

import {
    screenSmallerThan,
    Screen,
    screenBiggerThan,
} from '@client/styles/styled-components/breakpoints';

export const MainWrapper = styled.main`
    position: relative;
    background-color: ${BackgroundColor.mylounge};

    ${screenSmallerThan(Screen.smallTablet)} {
        padding-left: 0;
        padding-right: 0;
    }
`;

export const TitleWrapper = styled(Title)`
    margin: 0;
    text-transform: initial;
`;

export const CampaignsWrapper = styled.div`
    margin: ${Spacer.XL} 0 ${Spacer.XL} 0;
    ${mediaMaxWidth.sm} {
        margin: ${Spacer.M} 0 ${Spacer.M} 0;
    }
`;

export const GridWrapper = styled.ul`
    width: 100%;
    display: grid;
    gap: ${Spacer.S};
    position: relative;
    grid-template-columns: repeat(1, 1fr);

    ${screenBiggerThan(Screen.smallTablet)} {
        grid-template-columns: repeat(2, 1fr);
    }

    ${screenBiggerThan(Screen.tablet)} {
        grid-template-columns: repeat(4, 1fr);
        gap: ${Spacer.L};
    }
`;

export const BreadcrumbWrapper = styled.div`
    margin: ${Spacer.M} 0;
`;

export const StyledChevronLeft = styled(ChevronLeftXS)`
    margin-right: ${Spacer.S};
`;
